import { buildFinishedClientBonusDetailsRows } from './buildFinishedClientBonusDetailsRows';
import { buildFinishedClientFreespinDetailsRows } from './buildFinishedClientFreespinDetailsRows';
import { FINISHED_BONUS_DETAILS_SOURCE } from './finishedBonusDetailsShared';

export const buildFinishedBonusDetailsRows = ({ bonus, extra = {}, freeSpin, sourceType }) => {
  if (sourceType === FINISHED_BONUS_DETAILS_SOURCE.CLIENT_FREESPIN) {
    return buildFinishedClientFreespinDetailsRows({ extra, freeSpin });
  }

  return buildFinishedClientBonusDetailsRows({ bonus });
};

export { buildFinishedClientBonusDetailsRows } from './buildFinishedClientBonusDetailsRows';
export { buildFinishedClientFreespinDetailsRows } from './buildFinishedClientFreespinDetailsRows';
export { FINISHED_BONUS_DETAILS_SOURCE } from './finishedBonusDetailsShared';

export const resolveFinishedBonusTitle = ({ bonus, freeSpin, lang, title }) => {
  if (title) {
    return title;
  }

  if (bonus != null) {
    return bonus.name ?? '';
  }

  const list = freeSpin?.freeSpin?.localizedInfoList;

  if (!list?.length) {
    return '';
  }

  return (list.find(info => info.language === lang) || list[0])?.name ?? '';
};

// the highlighted prefix shown before the title (BonusTitle), mirroring the bonus card.
// an explicit `title` override carries no separate highlighted part.
export const resolveFinishedBonusTitleHighlighted = ({ bonus, freeSpin, lang, title }) => {
  if (title) {
    return null;
  }

  if (bonus != null) {
    return bonus.nameHighlighted ?? null;
  }

  const list = freeSpin?.freeSpin?.localizedInfoList;

  if (!list?.length) {
    return null;
  }

  return (list.find(info => info.language === lang) || list[0])?.nameHighlighted ?? null;
};
